// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"3b1f8c18","824":"41d5272c","845":"43df4d5c"}[chunkId] + ".chunk.css";
};